import { graphql } from "msw";

const instance = {
    _id: "testinstance",
    _account: "MasterDocs",
    _organisation: "MasterDocs",
};

export const handlers = [
    graphql.query("currentInstance", (req, res, ctx) =>
        res(
            ctx.data({
                __typename: "Instance",
                currentInstance: instance,
            })
        )
    ),
];
